import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="select-all"
export default class extends Controller {
  static targets = ["master", "child"]

  toggle(event) {
    const checked = event.target.checked
    this.childTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
  }
}
